export default "__VITE_ASSET__ZHcHvj14__"